import Konva from "konva";
import { useEffect } from "react";
import { Box, chakra, Flex, Text, Image } from "@chakra-ui/react";
import { useMedia } from "@/hooks/useMedia";
import { useI18n } from "@/hooks/useI18n";

const Wrap = chakra(Box, {
  baseStyle: {
    w: "100%",
    // height: "300px",
  },
});

const Header = chakra(Flex, {
  baseStyle: {
    justifyContent: "space-between",
    alignItems: "center",
  },
});

const Reset = chakra(Box, {
  baseStyle: {
    color: "rgba(208, 68, 87, 1)",
    bgColor: "#FCEDEF",
    borderRadius: "6px",
    cursor: "pointer",
    padding: "5px 10px",
    fontSize: "14px",
    _hover: {
      opacity: 0.8,
    },
  },
});

const CanvasWrap = chakra(Flex, {
  baseStyle: {
    borderRadius: "12px",
    padding: "0px 20px",
    border: "1px solid #E3E4F1",
    background: "#EBEDF5",
    mt: "10px",
    height: "100%",
    justifyContent: "center",
    position: "relative",
    ".img": {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0px",
      left: "0",
    },
  },
});

const SignCanvas = ({
  stage,
  setStage,
  layer,
  setLayer,
  checkedSign,
  setCheckedSign,
  setIsDrew,
  signImgUrl,
  setSignImgUrl,
}) => {
  const { t } = useI18n();
  const { isMobile } = useMedia();

  useEffect(() => {
    drawLine();
  }, []);

  const drawLine = () => {
    const _stage = new Konva.Stage({
      container: "kyc-sign-canvas-container",
      width: 888,
      height: 300,
      // height: "100%",
    });

    const _layer = new Konva.Layer();

    _stage.add(_layer);

    var isPaint = false;
    var mode = "brush";
    var lastLine;

    _stage.container().style.backgroundColor = "#EBEDF5";

    _stage.on("mousedown touchstart", function (e) {
      setIsDrew(true);
      isPaint = true;
      var pos = _stage.getPointerPosition();
      lastLine = new Konva.Line({
        stroke: "#df4b26",
        strokeWidth: 5,
        globalCompositeOperation:
          mode === "brush" ? "source-over" : "destination-out",
        points: [pos.x, pos.y],
      });
      _layer.add(lastLine);
    });

    _stage.on("mouseup touchend", function () {
      isPaint = false;
    });

    // and core function - drawing
    _stage.on("mousemove touchmove", function (e) {
      if (!isPaint) {
        return;
      }

      const pos = _stage.getPointerPosition();
      var newPoints = lastLine.points().concat([pos.x, pos.y]);
      lastLine.points(newPoints);
      _layer.batchDraw();
    });

    setStage(_stage);

    setLayer(_layer);
  };

  const resetLayer = () => {
    if (signImgUrl) {
      setSignImgUrl("");
    } else {
      layer.destroy();
      setIsDrew(false);
      drawLine();
    }
  };

  return (
    <Wrap mt={isMobile ? "30px" : "60px"} mb={isMobile ? "50px" : "30px"}>
      <Header>
        <Text fontSize={"14px"} color={"#010313"}>
          {t("unWQQLsJSfrIIVJn")}
        </Text>
        <Reset onClick={() => resetLayer()}>{t("qbHUBpWEdCDjRlJVlG")}</Reset>
      </Header>
      <CanvasWrap>
        <div id="kyc-sign-canvas-container"></div>
        {signImgUrl && <Image src={signImgUrl} className="img" />}
      </CanvasWrap>
      <Flex mt={"20px"} alignItems={"flex-start"}>
        <Image
          src={
            checkedSign
              ? "../../wwwsite/images/kyc/checked.svg"
              : "../../wwwsite/images/kyc/no_check.svg"
          }
          width={"18px"}
          height={"18px"}
          mt={"2px"}
          style={{
            cursor: "pointer",
            marginRight: "8px",
          }}
          onClick={() => setCheckedSign(!checkedSign)}
        />
        <Text color={"#010313"} fontSize={"14px"}>
          {t("XnFgMBFjdVitebCYI")}
        </Text>
      </Flex>
    </Wrap>
  );
};

export default SignCanvas;
